import { useTranslation } from "react-i18next";
import { CardReceive, CardSend, Repeat } from "iconsax-react";
import type { Locale } from "@/shared/utils";
import { formatMoneyKzt } from "@/shared/utils";
import type { MoneyAmount } from "../../../types";

interface SummaryCardsProps {
  creditTotal: MoneyAmount;
  debitTotal: MoneyAmount;
  transactionCount: number;
  locale: Locale;
}

function formatMoney(amount: MoneyAmount, locale: Locale): string {
  if (amount.currency === "KZT") return formatMoneyKzt(amount.amount, locale);
  return `${amount.amount.toLocaleString()} ${amount.currency}`;
}

export default function SummaryCards({ creditTotal, debitTotal, transactionCount, locale }: SummaryCardsProps) {
  const { t } = useTranslation("BankingPage");

  const cards = [
    {
      key: "income",
      label: t("summary.income"),
      value: formatMoney(creditTotal, locale),
      icon: CardReceive,
      iconColor: "viz-categorical-03-fill",
    },
    {
      key: "expenses",
      label: t("summary.expenses"),
      value: formatMoney(debitTotal, locale),
      icon: CardSend,
      iconColor: "viz-categorical-04-fill",
    },
    {
      key: "count",
      label: t("summary.count"),
      value: transactionCount.toString(),
      icon: Repeat,
      iconColor: "viz-categorical-05-fill",
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div key={card.key} className="p-5 radius-lg border surface-base-fill surface-component-stroke flex flex-col">
            <div className="flex items-center gap-3 mb-3">
              <div
                className={`w-8 aspect-square flex justify-center items-center text-white radial-glow surface-component-fill radius-xs ${card.iconColor}`}>
                <Icon size={16} color="currentColor" />
              </div>
              <p className="text-label-sm content-base-primary">{card.label}</p>
            </div>
            <h6 className="text-display-sm content-base-primary">{card.value}</h6>
          </div>
        );
      })}
    </div>
  );
}

